export default (to, from, next) => {
  let token = localStorage.getItem('token');
  if (!token) {
    next({ name: 'EmployerLogin' });
    return false;
  }
};

export const UserMiddleware = (to, from, next) => {
  let token = localStorage.getItem('token');
  if (token) {
    next({ name: 'EmployerDasboard' });
    return false;
  }
};
